import type { RouteRecordRaw } from 'vue-router'
import { PERMISSIONS } from '@/core/permissions/constants'

const AurumSeatCatalogView = () => import('@/modules/aurum/views/AurumSeatCatalogView.vue')
const AurumCheckInView = () => import('@/modules/aurum/views/AurumCheckInView.vue')

export const aurumRoutes: RouteRecordRaw[] = [
  {
    path: '/aurum',
    name: 'AurumSeatCatalog',
    component: AurumSeatCatalogView,
    meta: {
      permission: PERMISSIONS.ESHOP.MANAGE,
      projectScoped: true,
      title: 'Aurum'
    }
  },
  {
    path: '/aurum/check-in',
    name: 'AurumCheckIn',
    component: AurumCheckInView,
    meta: {
      permission: PERMISSIONS.ESHOP.VIEW,
      projectScoped: true,
      title: 'Aurum check-in'
    }
  }
]
